{
  "pt": {
    "question": {
      "actions": {
        "addDocuments": "Adicionar documentos",
        "cancel": "Cancelar",
        "createQuestion": "Criar pergunta",
        "delete": "Eliminar",
        "deleteDocuments": "Eliminar documentos",
        "edit": "Editar",
        "moveDown": "Mover para baixo",
        "moveUp": "Mover para cima",
        "new": "Pergunta",
        "save": "Guardar"
      },
      "attributes": {
        "answer": "Resposta",
        "documents": "Documentos / Imagens",
        "name": "Pergunta",
        "question": "Pergunta"
      },
      "labels": {
        "editQuestion": "Editar pergunta",
        "newQuestion": "Nova pergunta"
      },
      "toasts": {
        "create": "Pergunta criada",
        "delete": "Pergunta eliminada",
        "update": "Pergunta atualizada"
      },
      "validation": {
        "needAnswer": "Resposta necessária",
        "needQuestion": "Pergunta necessária"
      }
    }
  }
}
